


































import schema from 'async-validator'
import { Form, FormItem, Input, Button } from 'element-ui'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

import FieldError from '@/components/FieldError.vue'

import ErrorEntities from '@/models/error-entities'

import GroupedErrorValidationMixin from '@/mixins/GroupedErrorValidationMixin.vue'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    FieldError,
  },
})
export default class ForgotPasswordForm extends GroupedErrorValidationMixin {
  @Prop() serverErrors!: ErrorEntities
  @Prop() pending!: boolean
  @Ref() readonly forgotPasswordForm!: Form

  form = { email: '' }

  rules = {
    email: [
      { required: true, message: 'Email is required', trigger: 'blur' },
      {
        type: 'email',
        message: 'Please provide a valid email',
        trigger: 'blur',
      },
    ],
  }

  readonly validator = new schema(this.rules)

  submit() {
    this.forgotPasswordForm.validate((isValid) => {
      if (isValid) {
        this.$emit('on-forgot-password', this.form.email)
      }
    })
  }
}
